import { Check } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { NULL_VALUE } from 'constants/displayConstants';
import { resourceHasChecklistForCategory } from '../EventsTab/categoryChecklistMatch';
import type { ResourceRow } from './ResourceTabCard';

export function ResourceThreatChecklistBadge({
  threat,
  hasChecklist,
}: {
  threat: string;
  hasChecklist: boolean;
}) {
  return (
    <Badge
      variant={hasChecklist ? 'secondary' : 'outline'}
      className="tw:max-w-full tw:whitespace-normal tw:text-[10px]"
    >
      {hasChecklist ? <Check data-icon="inline-start" /> : null}
      {threat}
    </Badge>
  );
}

export function ResourceThreatChecklistBadges({
  threats,
  threat_checklists,
}: {
  threats: ResourceRow['threats'];
  threat_checklists: ResourceRow['threat_checklists'];
}) {
  const names = (threats ?? []).filter((threat) => threat.trim().length > 0);
  if (names.length === 0) {
    return (
      <span className="tw:text-xs tw:text-muted-foreground">{NULL_VALUE}</span>
    );
  }

  return (
    <div
      className="tw:flex tw:flex-wrap tw:items-center tw:gap-1"
      onClick={(event) => event.stopPropagation()}
    >
      {names.map((threat) => (
        <ResourceThreatChecklistBadge
          key={threat}
          threat={threat}
          hasChecklist={resourceHasChecklistForCategory(
            { threats, threat_checklists },
            threat
          )}
        />
      ))}
    </div>
  );
}
